import { DOCUMENT, isPlatformBrowser } from '@angular/common'
import { Injectable, PLATFORM_ID, Signal, signal, inject } from '@angular/core'

@Injectable({
    providedIn: 'root'
})
export class ThemeService {
    private _theme = signal<string | null>(null)
    private body = null as unknown as HTMLElement
    private themeLink = null as unknown as HTMLLinkElement

    private document = inject<Document>(DOCUMENT)

    constructor() {
        const platformId = inject(PLATFORM_ID)

        let theme = 'light'
        const isBrowser = isPlatformBrowser(platformId)

        if (isBrowser) {
            if (window && window.matchMedia && window.matchMedia('(prefers-color-scheme: light)').matches) {
                theme = 'light'
            }
            theme = localStorage.getItem('theme') || theme
        }

        this.body = this.document.body
        this.themeLink = this.document.getElementById('theme-link') as HTMLLinkElement
        this.set(theme)
    }

    private change(theme: string): void {
        if (this.body === null) return

        this.body.classList.remove('theme--dark')
        this.body.classList.remove('theme--light')
        this.body.classList.add(`theme--${theme}`)

        if (this.themeLink !== null) {
            this.themeLink.href = `theme-${theme}.css`
        }

        localStorage.setItem('theme', theme)
    }

    public get(): Signal<string | null> {
        return this._theme
    }

    public set(value: string | null): void {
        this._theme.set(value)
        this.change(value || 'light')
    }

    public addClassToBody(className: string): void {
        if (this.body === null) return
        this.body.classList.add(className)
    }

    public removeClassFromBody(className: string): void {
        if (this.body === null) return
        this.body.classList.remove(className)
    }
}
